import { createSelector } from "reselect";
import { sectionsSelector } from "../../sections_selector";

export const patientsSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.patients;
  }
);
